import { NextPage } from 'next';
import React from 'react';
import GuardAccount from '~/components/GuardAccount';
import GuardElectronKioskMode from '~/components/GuardElectronKioskMode';
import Meta from './meta';
import Page from './Page';
const Index: NextPage = (): React.ReactElement => <GuardAccount data-sentry-element="GuardAccount" data-sentry-component="Index" data-sentry-source-file="index.tsx">
    <GuardElectronKioskMode action="exit" data-sentry-element="GuardElectronKioskMode" data-sentry-source-file="index.tsx">
      <Page data-sentry-element="Page" data-sentry-source-file="index.tsx" />

      <Meta data-sentry-element="Meta" data-sentry-source-file="index.tsx" />
    </GuardElectronKioskMode>
  </GuardAccount>;
export default Index;